import WrittenSupervision  from './WrittenSupervision.vue'
export default WrittenSupervision
